import { FunctionComponent } from "react";

// import * as styles from "./Growl.css";
import { growlScript } from "./Growl.scripts";

/**
 * Growl component - a notification-style paywall prompt that appears
 * at the bottom of the viewport. This is a static component intended
 * for Zephr remote template loading.
 */
const Growl: FunctionComponent = () => {
  return (
    <>
      <div id="zephr-footer-container" className="duet--growl" data-brandid="0">
        <div id="zephr-footer-body">
          <span id="zephr-footer-body-subheading">{"{{{body-text}}}"}</span>
          <button
            id="zephr-footer-body-button"
            {...({
              onclick:
                'onSelect("{{body-button-text}}", "{{body-button-url}}")',
            } as React.ButtonHTMLAttributes<HTMLButtonElement>)}
            aria-label="Subscribe"
          >
            {"{{body-button-text}}"}
          </button>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: growlScript }} />
    </>
  );
};

export default Growl;
